export enum AdminProductListAction {
  Create,
}
